import { FormStepGroupType } from "../../types";

export const travelPlansGroup: FormStepGroupType = {
  name: "travel-plans",
  title: "Travel Plans",
  subTitle: "Helps us prioritize your application if you have an upcoming trip",
  collapsible: true,
  optional: true,
  hasSeparationLine: true,
  class: "group--travelPlans",
  fields: [
    {
      component: "Date",
      name: "dateTrip",
      label: "Date of Your Next Trip Abroad",
      type: "date",
      minElegibleDate: "today",
      maxElegibleDate: "dateReturn",
      validation: {},
      cols: 6,
      placeholder: "Please select a date.",
    },
    {
      component: "Date",
      name: "dateReturn",
      label: "Date of Your Return",
      type: "date",
      minElegibleDate: "dateTrip",
      validation: {},
      cols: 6,
      placeholder: "Please select a date.",
    },
    {
      component: "TextInput",
      name: "countriesVisited",
      label: "Which countries are you visiting?",
      type: "text",
      placeholder: "",
      maxLength: 28,
      validation: {
        maxLength: 28,
      },
      cols: 12,
    },
  ],
};
